<template>
  <b-list-group flush class="my--3">
    <b-row align-v="center">
      <b-col  class="ml-0">
        <h4>{{yearlyV}}</h4>
        <h5>
          <span>Data Volume this Year (MB)</span>
          <span class="float-right">{{yearlyP}}</span>
        </h5>
        <b-progress
        >
          <b-progress-bar variant="primary" :value="yearlyP"></b-progress-bar>
        </b-progress>
      </b-col>
    </b-row>

    <b-row align-v="center">
      <b-col  class="ml-0">
        <h4>{{billingV}}</h4>
        <h5>
          <span>Data Volume this Billing Period (MB)</span>
          <span class="float-right">{{billingP}}</span>
        </h5>
        <b-progress
        >
          <b-progress-bar variant="light" :value="billingP"></b-progress-bar>
        </b-progress>
      </b-col>
    </b-row>

    <b-row align-v="center">
      <b-col  class="ml-0">
        <h4>{{monthlyV}}</h4>
        <h5>
          <span>Data Volume this Month (MB)</span>
          <span class="float-right">{{monthlyP}}</span>
        </h5>
        <b-progress
        >
          <b-progress-bar variant="warning"  :value="monthlyP"></b-progress-bar>
        </b-progress>
      </b-col>
    </b-row>

    <b-row align-v="center">
      <b-col  class="ml-0">
        <h4>{{dailyV}}</h4>
        <h5>
          <span>Data Volume today (MB)</span>
          <span class="float-right">{{dailyP}}</span>
        </h5>
        <b-progress
        >
          <b-progress-bar variant="light"  :value="dailyP"></b-progress-bar>
        </b-progress>
      </b-col>
    </b-row>

  </b-list-group>
</template>

<script>
  import { BaseProgress } from '@/components';

    export default {
        name: "Data-Volume-Progress",
      props: {
        itemLimit: {
          type: Number,
          default: 4
        },
      },
      components: {
        BaseProgress
      },
      data() {
        return {
          yearlyV: '0',
          yearlyP: 0,
          billingP: '0',
          billingV: 0,
          monthlyV: '0',
          monthlyP: 0,
          dailyV: '0',
          dailyP: 0,
        }
      },
      methods: {

      },
      mounted() {
        this.$root.$on('dataVolumeAverageByIMSI', (data) => {
          this.yearlyV = data.yearlyV;
          this.yearlyP = data.yearlyP;
          this.monthlyV = data.monthlyV;
          this.monthlyP = data.monthlyP;
          this.dailyV = data.dailyV;
          this.dailyP = data.dailyP;
          this.billingV = data.billingV;
          this.billingP = data.billingP
        })
      },
    }
</script>
